import * as browser from './Browser/index';
import * as changes from './Changes/index';
import * as crContentDimensions from './CR/ContentDimensions/index';
import * as crNodeOperations from './CR/NodeOperations/index';
import * as crPolicies from './CR/Policies/index';
import * as publish from './Publish/index';
import * as serverFeedback from './ServerFeedback/index';
import * as uiContentCanvas from './UI/ContentCanvas/index';
import * as uiContentTree from './UI/ContentTree/index';
import * as uiEditPreviewMode from './UI/EditPreviewMode/index';
import * as uiInspector from './UI/Inspector/index';
import * as uiPageTree from './UI/PageTree/index';
import * as uiHotkeys from './UI/Hotkeys/index';

module.exports = {
    browser,
    changes,
    crContentDimensions,
    crNodeOperations,
    crPolicies,
    publish,
    serverFeedback,
    uiContentCanvas,
    uiContentTree,
    uiEditPreviewMode,
    uiInspector,
    uiPageTree,
    uiHotkeys
};
